import React, { useState, useEffect } from 'react';
import './TopBar.css';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { ImageAssets } from '../../common/Image';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

function TopBar({ isAdminPage }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [expanded, setExpanded] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

    useEffect(() => {
        const setVh = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        setVh();
        window.addEventListener('resize', setVh);
        return () => window.removeEventListener('resize', setVh);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 991);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isLoggedIn = !!sessionStorage.getItem("token");
    const isAdmin = sessionStorage.getItem("role")?.toUpperCase() === "ADMIN";

    const handleLogout = async () => {
        try {
            const token = sessionStorage.getItem("token");
            if (!token) return alert("로그인 상태가 아닙니다.");

            const response = await axios.post("https://air.aiia-gcu.com/auth/logout", {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                withCredentials: true
            });

            if (response.data.success) {
                alert(response.data.message);
                sessionStorage.clear();
                navigate("/");
            } else {
                alert("로그아웃 실패: " + response.data.message);
            }
        } catch (error) {
            alert("로그아웃 중 오류가 발생했습니다.");
        }
    };

    const isActive = (path) => location.pathname === path;

    return (
        <Navbar expanded={expanded} expand="lg" className="TopNav">
            <Container className="TopNav-Content">
                <Navbar.Brand as={Link} to={isAdminPage ? "/admin/attendance/calendar" : "/"}>
                    <img className="Logo" src={ImageAssets.logo_aiia} alt="logo" />
                </Navbar.Brand>
                <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    onClick={() => setExpanded(!expanded)}
                    className="custom-toggler"
                />
                <Navbar.Collapse id="basic-navbar-nav">
                    {isAdminPage ? (
                        <>
                            <Nav className="Menu">
                                <div className="admin-badge">
                                    <img src={ImageAssets.icon_admin} alt="admin" className="admin-icon" />
                                    <span className="admin-text">관리자 페이지</span>
                                </div>
                            </Nav>
                            <Nav className="Actions">
                                <Nav.Link as={Link} to="/" onClick={() => setExpanded(false)}>Main Home</Nav.Link>
                            </Nav>
                        </>
                    ) : (
                        <>
                            <Nav className="Menu">
                                <Nav.Link as={Link} to="/member" onClick={() => setExpanded(false)}>멤버정보</Nav.Link>
                                {isLoggedIn && (
                                    <>
                                        {!isMobile && (
                                            <Nav.Link as={Link} to="/calendar" onClick={() => setExpanded(false)}>일정관리</Nav.Link>
                                        )}
                                        <Nav.Link as={Link} to="/attendance" onClick={() => setExpanded(false)}>출석체크</Nav.Link>
                                        <Nav.Link onClick={() => {
                                            window.open('https://carnelian-vibraphone-f70.notion.site/1e4c321bf3d280f6b437cc0b06c5bb3d?pvs=105', '_blank');
                                            setExpanded(false);
                                        }}>결석계</Nav.Link>
                                    </>
                                )}
                            </Nav>
                            <Nav className="Actions">
                                {isLoggedIn ? (
                                    <>
                                        <Nav.Link as={Link} to="/me" onClick={() => setExpanded(false)}>
                                            <img src={ImageAssets.icon_profile} alt="profile" className="Nav-Icon" />
                                        </Nav.Link>
                                        {isAdmin && !isMobile && (
                                            <Nav.Link as={Link} to="/admin/attendance/calendar" onClick={() => setExpanded(false)}>
                                                <img src={ImageAssets.icon_admin} alt="admin" className="Nav-Icon" />
                                            </Nav.Link>
                                        )}
                                        <Nav.Link as={Link} to="/" onClick={() => {
                                            handleLogout();
                                            setExpanded(false);
                                        }}>로그아웃</Nav.Link>
                                    </>
                                ) : (
                                    <Nav.Link as={Link} to="/login" onClick={() => setExpanded(false)}>로그인</Nav.Link>
                                )}
                            </Nav>
                        </>
                    )}
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default TopBar;
